import React from "react";
import { Badge } from "../design/badge";
import { RelationshipToChild } from "@visitproof/types";

interface RelationshipToChildBadgeProps {
  status: RelationshipToChild | string;
}

const RelationshipToChildBadge: React.FC<RelationshipToChildBadgeProps> = ({
  status,
}) => {
  return <Badge>{status.charAt(0).toUpperCase() + status.slice(1)}</Badge>;
};

export default RelationshipToChildBadge;
